import { Icon } from '@chakra-ui/react';

export const CustomRedDownArrowIcon = (props) => (
  <Icon viewBox="0 0 48 26" fill="none" {...props}>
    <path
      d="M32.7227 25.8846H46.5688V12.1704"
      stroke="#FF0000"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M46.5702 25.8846L27.0126 6.51322C26.689 6.19911 26.2541 6.02317 25.801 6.02317C25.348 6.02317 24.913 6.19911 24.5895 6.51322L16.628 14.3989C16.3044 14.713 15.8695 14.889 15.4164 14.889C14.9634 14.889 14.5284 14.713 14.2049 14.3989L1.57031 1.88464"
      stroke="#FF0000"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </Icon>
);
